// extracted by mini-css-extract-plugin
export default {"tip":"RealNameModal_tip_Jp4PY"};